export default {
      id: "sli-upload-2-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "img/icons.9328ef59.svg#sli-upload-2",
      toString: function () {
        return this.url;
      }
    }